import { definePartner } from "../definePartner";

/**
 * Reelo: lists and applies offers; the backend skips the customer check for it.
 *
 * The app has no conversation of its own with it yet: every conversation field is the baseline's,
 * exactly as before it had a folder (R2.2 changed no behaviour). A gap between what the backend
 * offers and what the app does is asked when R2.4 builds the partner steps (DISCOUNT_V2_PLAN.md §9.12).
 */
export default definePartner("reelo", {
  name: "Reelo",
  backend: {
    listsOffers: true,
    appliesOffers: true,
    applyOtp: "skipped",
    takesTypedCodes: false,
    releaseNeeds: [],
    exercisedAtSave: false,
  },
  // The backend defines `refundLoyaltyPoints` for it (points-conversations.md §2).
  refundsPoints: true,
});
